@use '../../../../../styles/Constants.scss' as Constants;
@use '../../../../../styles/Colors.scss' as Colors;

.preview-container {
	background-color: Colors.$col-white;
	padding-bottom: Constants.$val-spacing-m;
}

.section-title {
	text-transform: uppercase;
	padding-top: Constants.$val-spacing-m;
	padding-bottom: Constants.$val-spacing-m;
}

.expired-msg {
	color: Colors.$col-red;
	font-weight: bold;
}

